import React, { lazy } from 'react';
import { ArrowRight, Star, ShieldCheck, Flame } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function PricingSection() {
  return <section id="offer" className="bg-gradient-to-b from-volley-navy to-volley-navy-dark py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-145">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-volley-teal/10 rounded-full blur-3xl pointer-events-none" data-id="element-146"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-147">
        <div className="bg-white/10 backdrop-blur-md border border-white/20 text-white font-semibold text-xs px-4 py-1.5 rounded-full mb-8 inline-block uppercase tracking-[0.2em]" data-id="element-148">
          OFFERTA SPECIALE — PACCHETTO COMPLETO 6-IN-1
        </div>
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-white leading-tight mb-6 tracking-tight" data-id="element-149">
          Accedi al sistema ora e trasforma i tuoi allenamenti{' '}
          <span className="italic text-volley-orange" data-id="element-150">oggi stesso</span>
        </h2>

        <div className="mb-10 max-w-md mx-auto mt-12 relative" data-id="element-151">
          <div className="absolute inset-0 bg-volley-orange/10 rounded-3xl blur-2xl transform translate-y-4" data-id="element-152"></div>
          <img src="https://cdn.magicpatterns.com/uploads/jjRs1JqwthzyTRBN5QdTiY/image_(8).webp" alt="Volley Pronto 6-in-1 Box Set" className="relative w-full rounded-3xl shadow-2xl border border-white/10" loading="lazy" decoding="async" width="800" height="800" data-id="element-153" />
        </div>

        <div id="pricing-card" className="bg-white rounded-[2rem] p-8 sm:p-10 shadow-2xl max-w-md mx-auto scroll-mt-8 relative overflow-hidden" data-id="element-154">
          <div className="absolute top-0 inset-x-0 h-2 bg-gradient-to-r from-volley-orange to-volley-orange-dark" data-id="element-155"></div>

          <p className="text-volley-slate text-sm mb-2 font-medium" data-id="element-156">
            Prezzo Normale:{' '}
            <span className="line-through text-volley-gray" data-id="element-157">€97 EUR</span>
          </p>

          <div className="inline-flex items-center gap-2 bg-volley-orange/10 text-volley-orange-dark text-xs font-bold px-4 py-2 rounded-full my-4 uppercase tracking-wide" data-id="element-158">
            <Flame className="w-4 h-4" data-id="element-159" /> 80% DI SCONTO — Offerta di Lancio
          </div>

          <p className="text-volley-slate text-sm mb-2 mt-2" data-id="element-160">
            Prezzo per tempo limitato:
          </p>
          <p className="font-display text-7xl sm:text-8xl font-semibold text-volley-dark mb-2 leading-none tracking-tight" data-id="element-161">
            €19
          </p>
          <p className="text-volley-slate text-sm mb-6 font-medium" data-id="element-162">
            Pagamento unico. Nessun abbonamento.
          </p>

          <p className="text-volley-orange-dark font-semibold text-sm mb-6 flex items-center justify-center gap-1.5 bg-volley-orange/5 py-2 px-4 rounded-lg" data-id="element-163">
            🔥 Ultima occasione! Il prezzo aumenterà allo scadere del timer.
          </p>

          <div className="mb-8" data-id="element-164">
            <CountdownTimer data-id="element-165" />
          </div>

          <a href="https://pilates-ready.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="group w-full bg-gradient-to-r from-volley-orange to-volley-orange-dark text-white font-semibold text-base sm:text-lg py-4 px-6 rounded-full shadow-[0_10px_30px_rgba(238,122,35,0.4)] hover:shadow-[0_15px_40px_rgba(238,122,35,0.6)] hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-3" data-id="element-166">
            <span data-id="element-167">🚀 SÌ, VOGLIO IL PACCHETTO 6-IN-1 (€19)</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-168" />
          </a>

          <div className="mt-8 flex flex-col items-center gap-3 pt-6 border-t border-volley-gray/20" data-id="element-169">
            <div className="flex items-center gap-2" data-id="element-170">
              <div className="flex text-volley-yellow" data-id="element-171">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-172" />)}
              </div>
              <span className="text-volley-slate text-sm font-medium" data-id="element-173">
                4.9/5 — Recensioni Verificate
              </span>
            </div>
            <div className="flex items-center gap-2 text-volley-slate text-sm" data-id="element-174">
              <ShieldCheck className="w-4 h-4 text-volley-teal" data-id="element-175" />
              <span data-id="element-176">Garanzia 7 Giorni — Zero Rischi</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}